<template>
  <component :is="type" v-bind="linkProps(to)" @click.native="refresh">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    type() {
      if (this.isExternal) {
        return 'a'
      }
      return 'router-link'
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        //此处更新跳转路径
        let path = `http://app.zhgylgl.com/owner/index.html?user_id=${localStorage.getItem("userId")}`;
        return {
          // href: to,
          href: path,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        to: to
      }
    },
    async refresh(a){
      await this.$store.dispatch("user/setResetMain",false);
      await this.$store.dispatch("user/setResetMain",true);
    }
  }
}
</script>
